import { Component, inject } from '@angular/core';
import {MaandJaar} from '../../../core/date/maand-jaar';
import {downloadCsvFile, parseJsonToCsv} from '../../../core/file/file';
import {PrestatieCijfersService} from '../../../exports/prestatie-cijfers.service';
import {ActiviteitCijfersService} from '../../../exports/activiteit-cijfers.service';
import {NotificationService} from '../../../core/notification/notification.service';
import {tap} from 'rxjs/operators';
import {ExportOption} from '../../../exports/export-option';

@Component({
    templateUrl: './exports-page.component.html',
    styleUrls: ['./exports-page.component.scss'],
    standalone: false
})
export class ExportsPage {
  private prestatiecijfersService = inject(PrestatieCijfersService);
  private activiteitCijfersService = inject(ActiviteitCijfersService);
  private notificationService = inject(NotificationService);

  downloadExport([exportOption, maandJaar]: [ExportOption, MaandJaar]): void {
    if (exportOption === ExportOption.PRESTATIECIJFER) {
      this.downloadPrestatieCijfers(maandJaar);
    } else if (exportOption === ExportOption.TAAKCIJFER) {
      this.downloadTaakCijfers(maandJaar);
    } else if (exportOption === ExportOption.ACTIVITEITCIJFER) {
      this.downloadActiviteitCijfers(maandJaar);
    }
  }

  private downloadPrestatieCijfers(maandJaar: MaandJaar) {
    this.prestatiecijfersService
      .downloadPrestatieCijfers$(maandJaar)
      .pipe(tap(prestatieCijfers => this.saveCsv(maandJaar, prestatieCijfers, 'prestatiecijfers')))
      .subscribe();
  }

  private downloadTaakCijfers(maandJaar: MaandJaar) {
    this.prestatiecijfersService
      .downloadTaakCijfers$(maandJaar)
      .pipe(tap(taakCijfers => this.saveCsv(maandJaar, taakCijfers, 'taakcijfers')))
      .subscribe();
  }

  private downloadActiviteitCijfers(maandJaar: MaandJaar) {
    this.activiteitCijfersService
      .downloadActiviteitCijfers$(maandJaar)
      .pipe(tap(taakCijfers => this.saveCsv(maandJaar, taakCijfers, 'activiteitcijfers')))
      .subscribe();
  }

  private saveCsv(maandJaar: MaandJaar, cijfers: Array<any>, label: string): void {
    if (cijfers.length === 0) {
      this.notificationService.showWarning(`Geen ${label} gevonden voor deze maand`);
    } else {
      downloadCsvFile(
        parseJsonToCsv(cijfers),
        `${label}-${maandJaar.maand}-${maandJaar.jaar}`);
    }
  }
}
